module.exports = __webpack_public_path__ + "img/logoN.87aaf2a4.png";